import { Quote } from 'lucide-react';

const TEAL = '#14b8a6';

const testimonials = [
  {
    quote: "We switched from a legacy AMS that cost us $15,000/year and required a dedicated admin. TheOne AMS does everything it did and more, at a fraction of the cost. Our board was stunned.",
    name: 'Patricia Hawkins',
    role: 'Executive Director',
    org: 'Northwest Builders Association',
  },
  {
    quote: "The HOA vertical is a game-changer. Violation tracking, architectural reviews, assessment billing — it handles the things generic AMS platforms always got wrong. Our property managers actually enjoy using it.",
    name: 'Michael Torres',
    role: 'Community Manager',
    org: 'Lakeside Estates HOA',
  },
  {
    quote: "We manage 4,200 member businesses across three counties. The chamber module with tiered memberships, event management, and the business directory is exactly what we needed. Implementation took two days.",
    name: 'Linda Park',
    role: 'VP of Membership',
    org: 'Metro Chamber of Commerce',
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-28 sm:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-ams-700/40 bg-ams-950/40 px-3 py-1 text-xs font-medium text-ams-400">
            Trusted by Organizations
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Organizations Like Yours Love TheOne AMS
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="reveal rounded-2xl border border-ams-800/30 bg-ams-950/20 p-6 backdrop-blur"
            >
              <Quote className="mb-4 h-6 w-6" style={{ color: `${TEAL}60` }} />
              <blockquote className="mb-6 text-sm leading-relaxed text-zinc-300">
                "{t.quote}"
              </blockquote>
              <div className="border-t border-ams-800/30 pt-4">
                <div className="text-sm font-semibold">{t.name}</div>
                <div className="text-xs text-zinc-500">
                  {t.role}, {t.org}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
